import React, { useEffect } from 'react'
import { useAuth } from '../../../firebase/AuthProvider';
import { Outlet } from 'react-router-dom';

const VideoCallRoute = () => {
    const {currentUser, currentRoles, currentUserInfo} = useAuth();
    useEffect(()=>{
        if(!currentUser){
            return;
        }

    },[currentUser]);
  return (
    <div>
        {currentUser && currentRoles  && currentUserInfo &&
            <Outlet />
        }
    </div>
  )
}

export default VideoCallRoute